module.exports = __webpack_public_path__ + "img/completar-espacios.91e170b0.svg";